/**
 * @fileoverview gRPC-Web generated client stub for proto
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: bankpb/request.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')

var trnspb_pendingtrns_pb = require('../trnspb/pendingtrns_pb.js')
const proto = {};
proto.proto = require('./request_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.RequestServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.proto.RequestServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.Request,
 *   !proto.proto.CreateResponse>}
 */
const methodDescriptor_RequestService_Create = new grpc.web.MethodDescriptor(
  '/proto.RequestService/Create',
  grpc.web.MethodType.UNARY,
  proto.proto.Request,
  proto.proto.CreateResponse,
  /**
   * @param {!proto.proto.Request} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.CreateResponse.deserializeBinary
);


/**
 * @param {!proto.proto.Request} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.CreateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.CreateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.RequestServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.RequestService/Create',
      request,
      metadata || {},
      methodDescriptor_RequestService_Create,
      callback);
};


/**
 * @param {!proto.proto.Request} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.CreateResponse>}
 *     Promise that resolves to the response
 */
proto.proto.RequestServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.RequestService/Create',
      request,
      metadata || {},
      methodDescriptor_RequestService_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.UpdateRequest,
 *   !proto.proto.UpdateResponse>}
 */
const methodDescriptor_RequestService_Update = new grpc.web.MethodDescriptor(
  '/proto.RequestService/Update',
  grpc.web.MethodType.UNARY,
  proto.proto.UpdateRequest,
  proto.proto.UpdateResponse,
  /**
   * @param {!proto.proto.UpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.UpdateResponse.deserializeBinary
);


/**
 * @param {!proto.proto.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.UpdateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.UpdateResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.RequestServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.RequestService/Update',
      request,
      metadata || {},
      methodDescriptor_RequestService_Update,
      callback);
};


/**
 * @param {!proto.proto.UpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.UpdateResponse>}
 *     Promise that resolves to the response
 */
proto.proto.RequestServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.RequestService/Update',
      request,
      metadata || {},
      methodDescriptor_RequestService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ReadRequest,
 *   !proto.proto.ReadResponse>}
 */
const methodDescriptor_RequestService_Read = new grpc.web.MethodDescriptor(
  '/proto.RequestService/Read',
  grpc.web.MethodType.UNARY,
  proto.proto.ReadRequest,
  proto.proto.ReadResponse,
  /**
   * @param {!proto.proto.ReadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ReadResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ReadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ReadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.RequestServiceClient.prototype.read =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.RequestService/Read',
      request,
      metadata || {},
      methodDescriptor_RequestService_Read,
      callback);
};


/**
 * @param {!proto.proto.ReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ReadResponse>}
 *     Promise that resolves to the response
 */
proto.proto.RequestServicePromiseClient.prototype.read =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.RequestService/Read',
      request,
      metadata || {},
      methodDescriptor_RequestService_Read);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ListRequest,
 *   !proto.proto.ListResponse>}
 */
const methodDescriptor_RequestService_List = new grpc.web.MethodDescriptor(
  '/proto.RequestService/List',
  grpc.web.MethodType.UNARY,
  proto.proto.ListRequest,
  proto.proto.ListResponse,
  /**
   * @param {!proto.proto.ListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ListResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.RequestServiceClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.RequestService/List',
      request,
      metadata || {},
      methodDescriptor_RequestService_List,
      callback);
};


/**
 * @param {!proto.proto.ListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ListResponse>}
 *     Promise that resolves to the response
 */
proto.proto.RequestServicePromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.RequestService/List',
      request,
      metadata || {},
      methodDescriptor_RequestService_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.ExecuteRequest,
 *   !proto.proto.ExecuteResponse>}
 */
const methodDescriptor_RequestService_Execute = new grpc.web.MethodDescriptor(
  '/proto.RequestService/Execute',
  grpc.web.MethodType.UNARY,
  proto.proto.ExecuteRequest,
  proto.proto.ExecuteResponse,
  /**
   * @param {!proto.proto.ExecuteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.ExecuteResponse.deserializeBinary
);


/**
 * @param {!proto.proto.ExecuteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.ExecuteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.ExecuteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.RequestServiceClient.prototype.execute =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.RequestService/Execute',
      request,
      metadata || {},
      methodDescriptor_RequestService_Execute,
      callback);
};


/**
 * @param {!proto.proto.ExecuteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.ExecuteResponse>}
 *     Promise that resolves to the response
 */
proto.proto.RequestServicePromiseClient.prototype.execute =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.RequestService/Execute',
      request,
      metadata || {},
      methodDescriptor_RequestService_Execute);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.proto.GetByExternalTransferIDRequest,
 *   !proto.proto.GetByExternalTransferIDResponse>}
 */
const methodDescriptor_RequestService_GetByExternalTransferID = new grpc.web.MethodDescriptor(
  '/proto.RequestService/GetByExternalTransferID',
  grpc.web.MethodType.UNARY,
  proto.proto.GetByExternalTransferIDRequest,
  proto.proto.GetByExternalTransferIDResponse,
  /**
   * @param {!proto.proto.GetByExternalTransferIDRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.proto.GetByExternalTransferIDResponse.deserializeBinary
);


/**
 * @param {!proto.proto.GetByExternalTransferIDRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.proto.GetByExternalTransferIDResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.proto.GetByExternalTransferIDResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.proto.RequestServiceClient.prototype.getByExternalTransferID =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/proto.RequestService/GetByExternalTransferID',
      request,
      metadata || {},
      methodDescriptor_RequestService_GetByExternalTransferID,
      callback);
};


/**
 * @param {!proto.proto.GetByExternalTransferIDRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.proto.GetByExternalTransferIDResponse>}
 *     Promise that resolves to the response
 */
proto.proto.RequestServicePromiseClient.prototype.getByExternalTransferID =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/proto.RequestService/GetByExternalTransferID',
      request,
      metadata || {},
      methodDescriptor_RequestService_GetByExternalTransferID);
};


module.exports = proto.proto;

